import { useQuery } from '@tanstack/react-query';
import { PaymentService } from '@/services/PaymentService';

function usePrices() {
  const fetchPrices = async () => {
    return PaymentService.getPrices();
  };

  const { data: prices = {}, isLoading: pricesLoading } = useQuery({
    queryKey: ['prices'],
    queryFn: fetchPrices,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    enabled: true,
  });

  return {
    prices,
    pricesLoading,
  };
}

export { usePrices };
